import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { FaCheckCircle, FaLeaf, FaTruck } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../ShoeCare/WorntoWow/WorntoWow.css";
import AOS from "aos";
import "aos/dist/aos.css";
// Custom Arrows
const PrevArrow = ({ onClick }) => (
    <div className="arrow prev" onClick={onClick}>
        <FaChevronCircleLeft />
    </div>
);
const NextArrow = ({ onClick }) => (
    <div className="arrow next" onClick={onClick}>
        <FaChevronCircleRight />
    </div>
);
const reviews = [
    {
        text: "/bagcare2.webp"
    },
    {
        text: "/bagcare3.webp"
    },
    {
        text: "/bagcare4.webp"
    },
    {
        text: "/bagcare5.webp"
    },
    {
        text: "/bagcare6.webp"
    },
    ,
    {
        text: "/bagcare7.webp"
    },
    ,
    {
        text: "/bagcare8.webp"
    },
    ,
    {
        text: "/bagcare3.webp"
    },

];

export default function WornWonder() {
    const [play, setPlay] = useState(false);

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1200, // small laptop
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768, // tablet
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
    };


    useEffect(() => {
        AOS.init({
            duration: 1200,
            easing: "ease-in-out",
            once: true,
            offset: 80,
        });
    }, []);
    return (
        <div className="slider-wrapper">
            <div className="row">
                <div className="col-sm-1"></div>
                <div className="col-sm-10">
                    <div className="worntoWow-wrapper">
                        <h2 style={{ fontSize: "30px", color: "rgb(75, 46, 131)", fontWeight: "bold" }}>From Worn to Wonder

                        </h2>
                        <p>Professional shoe cleaning and restoration services that bring the shine back.

                        </p>
                        <Slider {...settings}>
                            {reviews.map((item, index) => (
                                <div key={index}>
                                    <div className="worntoWow-box" data-aos="zoom-in-down">
                                        <span className="review-text">
                                            <img src={item.text} alt="" style={{ width: "100%", height: "250px" }} />
                                        </span>


                                    </div>
                                </div>
                            ))}
                        </Slider>

                    </div>

                </div>

                <div className="col-sm-1"></div>

            </div>

        </div>
    );
}
